module.exports = __webpack_public_path__ + "img/菁英icon.2d4c449b.png";